const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  if (body.code === 'PACKAGE_LIMIT_EXCEEDED' || body.code === 'PACKAGE_FEATURE_DISABLED') {
    throw new Error(body.message);
  }
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

export async function generateAiFinancialReport(companyId, periodId, reportingBasis = 'IFRS', locale = 'tr-TR', temperature = 0.3, trendStartPeriodId = null, trendEndPeriodId = null, trendMaxPeriods = null, provider = null) {
  const response = await fetch(`${API_BASE}/api/analysis/ai-report/generate`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify({
      companyId: Number(companyId),
      periodId: Number(periodId),
      reportingBasis,
      trendStartPeriodId: trendStartPeriodId != null ? Number(trendStartPeriodId) : null,
      trendEndPeriodId: trendEndPeriodId != null ? Number(trendEndPeriodId) : null,
      trendMaxPeriods: trendMaxPeriods != null ? Number(trendMaxPeriods) : null,
      locale,
      temperature,
      provider
    })
  });

  return handleErrors(response, 'AI mali analiz raporu olusturulamadi.');
}

export async function fetchAiProviders() {
  const response = await fetch(`${API_BASE}/api/analysis/ai-report/providers`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'AI provider listesi alinamadi.');
}

export async function fetchSavedAiFinancialReports(companyId, periodId) {
  const params = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId)
  });
  const response = await fetch(`${API_BASE}/api/analysis/ai-report/saved?${params.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Kayitli AI raporlari alinamadi.');
}

export async function fetchSavedAiFinancialReport(companyId, reportId) {
  const params = new URLSearchParams({
    companyId: String(companyId)
  });
  const response = await fetch(`${API_BASE}/api/analysis/ai-report/saved/${reportId}?${params.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Kayitli AI raporu alinamadi.');
}

export async function fetchAiTenantAdminOptions() {
  const response = await fetch(`${API_BASE}/api/analysis/ai-report/tenant-admin-options`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Tenant admin listesi alinamadi.');
}

const analysisAiReportService = {
  generateAiFinancialReport,
  fetchSavedAiFinancialReports,
  fetchSavedAiFinancialReport,
  fetchAiTenantAdminOptions,
  fetchAiProviders
};

export default analysisAiReportService;
